const APPLICATION_PATH = '/application';
const PAYMENT_PATH = '/payment';

/**
 * Where sign-up sends a learner who picked an externship before having an account.
 *
 * Sign-up only honours `redirect_url`, and every new account must pass through `/application`
 * before the paywall. So the externship rides as the application's own `redirect_url`, which
 * `resolveApplicationSuccessDestination` forwards to `/payment?externshipId=` once it is submitted.
 */
export function applicationRedirectUrl(externshipId: number): string {
  const paymentParams = new URLSearchParams({ externshipId: String(externshipId) });
  const applicationParams = new URLSearchParams({ redirect_url: `${PAYMENT_PATH}?${paymentParams.toString()}` });
  return `${APPLICATION_PATH}?${applicationParams.toString()}`;
}
